import { useOrganization } from "@/queries/organization-queries";
import { useGetPreferenceByKey } from "@/queries/user-preferences-queries";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

const DEVCONTAINER_EDUCATION_DISMISSED_KEY = "devcontainer_education_banner_dismissed";

export function useDevcontainerEducationVisible() {
    const { data: organization } = useOrganization();
    const { data: preference, isPending } = useGetPreferenceByKey(DEVCONTAINER_EDUCATION_DISMISSED_KEY);

    const isEnterprise = organization?.tier === OrganizationTier.ENTERPRISE;
    const isDismissed = preference?.value === "true";

    return !isEnterprise && !isDismissed && !isPending;
}
